// Tabs, not buttons: one white pill riding on a grey tray. `fill` spreads the
// options across the full width, which is what the household row wants.
const Segmented = ({ options, value, onChange, fill = false }) => (
  <div
    role="tablist"
    className={`inline-flex items-center gap-1 rounded-xl border border-gray-200 bg-secondary-50 p-1 ${fill ? 'w-full' : ''}`}
  >
    {options.map(({ key, label }) => (
      <button
        key={key}
        type="button"
        role="tab"
        aria-selected={key === value}
        onClick={() => onChange(key)}
        className={`rounded-lg border px-3 py-2 text-sm font-semibold transition-colors sm:px-4 ${fill ? 'flex-1' : ''} ${key === value
          ? 'border-gray-200 bg-white text-teamcare-blue shadow-sm'
          : 'border-transparent text-secondary-700 hover:text-secondary-900'
          }`}
      >
        {label}
      </button>
    ))}
  </div>
);

export default Segmented;
